import { Component, EventEmitter, HostListener, Input, Output, OnChanges, SimpleChanges, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MenuItem } from '../header.component';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { buildUrl } from '@shared/utilities/common.utils';
import { SITE_LINKS } from '@shared/constants/site-links.constants';
import { StorageService } from '@shared/services/storage/storage.service';
import { STORAGE } from '@shared/constants/storage.constants';
import { HeaderUserMenuComponent } from '@shared/components/header-user-menu/header-user-menu.component';
import { TabService } from '@shared/services/tab/tab.service';
import { ButtonComponent, ButtonThemes } from '@shared/components/button/button.component';
import { EXTERNAL_LINKS } from '@shared/constants/external-links.constants';
import { OrderRequestModalComponent } from '@shared/components/order-request-modal/order-request-modal.component';

@Component({
  selector: 'avenir-main-header',
  standalone: true,
  imports: [
    CommonModule,
    NgbDropdownModule,
    HeaderUserMenuComponent,
    ButtonComponent,
    OrderRequestModalComponent
  ],
  templateUrl: './main-header.component.html',
  styleUrl: './main-header.component.scss'
})
export class MainHeaderComponent implements OnChanges {
  modalService = inject(NgbModal);

  readonly BUTTON_THEME = ButtonThemes;

  @Input() customerId!: string;
  @Input() isLoggedIn: boolean = false;
  @Input() loggedInMenuItems!: MenuItem[];
  @Output() showSideNav = new EventEmitter<boolean>;

  desktopLoggedInMenuItems!: MenuItem[];

  //follow breakpoints.scss
  $l: number = 1150;

  hideAt$l: boolean = false;
  showAt$l: boolean = false;
  isModalVisible: boolean = false;
  isServiceModalVisible: boolean = false;
  isAtSignUpPage: boolean = false;
  isMenuHide: boolean = false

  orderPropaneLabel = $localize `:@@orderPropaneLabel:Order Propane`
  contactUsLabel = $localize `:@@ocontactUsLabel:Contact Us`

  constructor(
    private router: Router,
    private storageService: StorageService,
    private tabService: TabService,
    private activatedRoute: ActivatedRoute,
    private routerService: Router
  ){ 
    routerService.events.subscribe((route:any)=>{
      if(route instanceof NavigationEnd){
        if(route.url.includes('survey')){
          this.isMenuHide = true;
          console.log(this.isMenuHide);
            this.loggedInMenuItems = []
            this.desktopLoggedInMenuItems = []
        }
      }
    })
  }

  ngOnInit(){
    this.checkWidth( Math.min(window.outerWidth, window.innerWidth));

    this.tabService.selectedTab$.subscribe(tab => {
      this.selectedTab.set(parseInt(tab));
    });

    this.lastSelectedTab = localStorage.getItem('selectedTab');
    if(this.lastSelectedTab){
      this.selectedTab.set(parseInt(this.lastSelectedTab));
    }
    console.log(this.selectedTab());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isLoggedIn']) {
      this.isLoggedIn = changes['isLoggedIn'].currentValue;
    }

    if (changes['loggedInMenuItems']) {
      if(this.isMenuHide){
        this.loggedInMenuItems = []
        this.desktopLoggedInMenuItems = []
      }else{
        this.loggedInMenuItems = changes['loggedInMenuItems'].currentValue;
        this.desktopLoggedInMenuItems = this.loggedInMenuItems.filter(item => item.inDesktop);
      }
    }

    if (changes['customerId']) {
      let lastUrlSegment = this.router.url.substring(this.router.url.lastIndexOf('/') + 1);
      if (lastUrlSegment == 'dashboard') {
        localStorage.setItem('selectedTab', '10');
        this.selectedTab.set(10);
      } 
    }
  }


  lastSelectedTab: any;
  selectedTab = signal<number>(10);
  goToPage(url: string, event: Event, redirect: boolean, i: number){
    localStorage.setItem('selectedTab', i.toString());
    if(!redirect){
      event.stopPropagation();
    }
    if(url === '/open-account'){
      this.isAtSignUpPage = true;
    } else {
      this.isAtSignUpPage = false;
    }
    this.selectedTab.set(i);
    this.router.navigateByUrl(url);
  }

  openSideNav(){
    this.showSideNav.emit(true);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event : any) {    
    this.checkWidth( Math.min(event.target.innerWidth, event.target.outerWidth) );
  }

  checkWidth(width: any){
    if (width < this.$l) {
      this.hideAt$l = true;
      this.showAt$l = true;
    } else {
      this.hideAt$l = false;
      this.showAt$l = false;
    }
  }

  goToHomePage(){
    if (this.isLoggedIn) {
      this.router.navigateByUrl(buildUrl(SITE_LINKS.DASHBOARD, this.customerId));
      localStorage.setItem('selectedTab', '10');
      this.selectedTab.set(10);
    } else {
      this.isAtSignUpPage = false;
      this.router.navigateByUrl(buildUrl(SITE_LINKS.AUTH.LOGIN, 'residential'));
      //window.open('https://www.avenirenergy.ca/', "_blank");
    }
  }

  // goToRequestServicePage() {
  //   if (this.isLoggedIn) {
  //     this.router.navigateByUrl(buildUrl(SITE_LINKS.SERVICE.REQUEST, this.customerId));
  //   } else {
  //     this.router.navigateByUrl(buildUrl(SITE_LINKS.ROOT));
  //   }
  // }

  goToRequestServicePage() {
    this.showServiceModal();
  }

  goToOrderPropanePage() {
    this.showModal();
  }

  showServiceModal() {
    this.isServiceModalVisible = true;
  }

  showModal() {
    this.isModalVisible = true;
  }

  closeModal() {
    this.isModalVisible = false;
    this.isServiceModalVisible = false;
  }

  openOrderPropaneSite() {
    const modal = this.modalService.open(OrderRequestModalComponent, { size: 'md' });
    const modalRef = modal.componentInstance as OrderRequestModalComponent;
    modalRef.customerId = parseInt(this.customerId);
  }

  openContactUsSite() {
    window.open(EXTERNAL_LINKS.CONTACT_US, '_blank')
  }

  // goToOrderPropanePage() {
  //   if (this.isLoggedIn) {
  //     this.router.navigateByUrl(buildUrl(SITE_LINKS.DELIVERY.ADD, this.customerId));
  //   } else {
  //     this.router.navigateByUrl(buildUrl(SITE_LINKS.ROOT));
  //   }
  // }
}

